import MonitorRepository from '../../repositories/MonitorRepository';
import Vue from 'vue';
import ClientRepository from '../../repositories/ClientRepository';
import GroupRepository from '../../repositories/GroupRepository';
import DeviceRepository from '../../repositories/DeviceRepository';

export default {
	namespaced: true,
	state: {
		monitorActionTemplateAll: {}
	},
	mutations: {
		SET_MONITOR_ACTION_TEMPLATE_ALL (state, data) {
			data.forEach((element) => {
				Vue.set(state.monitorActionTemplateAll, element.id, element);
			});
		},
		REMOVE_MONITOR_ACTION_TEMPLATE (state, id) {
			Vue.delete(state.monitorActionTemplateAll, id);
		}
	},
	actions: {
		allActionGroupTemplates ({ commit, getters }) {
			return MonitorRepository.allActionGroupTemplates()
				.then(data => {
					commit('SET_MONITOR_ACTION_TEMPLATE_ALL', data);

					return data;
				});
		},
		deleteActionGroupTemplate ({ commit, getters }, id) {
			return MonitorRepository.deleteActionGroupTemplate(id)
				.then(data => {
					commit('REMOVE_MONITOR_ACTION_TEMPLATE', id);

					return data;
				});
		},
		getClientMonitors ({ commit, getters }, id) {
			return ClientRepository.getMonitors(id);
		},
		getClientTypes ({ commit, getters }, id) {
			return ClientRepository.getMonitorTypes(id);
		},
		getGroupMonitors ({ commit, getters }, request) {
			return GroupRepository.getMonitors(request.clientId, request.groupId);
		},
		getGroupInheritedMonitors ({ commit, getters }, request) {
			return GroupRepository.getInheritedMonitors(request.clientId, request.groupId);
		},
		getGroupTypes ({ commit, getters }, request) {
			return GroupRepository.getMonitorTypes(request.clientId, request.groupId);
		},
		getDeviceMonitors ({ commit, getters }, request) {
			return DeviceRepository.getMonitors(request.clientId, request.groupId, request.deviceId);
		},
		getDeviceInheritedMonitors ({ commit, getters }, request) {
			return DeviceRepository.getInheritedMonitors(request.clientId, request.groupId, request.deviceId);
		},
		getDeviceTypes ({ commit, getters }, request) {
			return DeviceRepository.getMonitorTypes(request.clientId, request.groupId, request.deviceId);
		},
		getMagTemplates ({ commit, getters }) {
			return MonitorRepository.allActionGroupTemplates();
		},
		fetchAvailableMagTemplates ({ commit, getters }, clientId) {
			return MonitorRepository.availableActionGroupTemplates(clientId);
		},
		getClientMonitorTypes ({ commit, getters }, request) {
			return ClientRepository.getMonitorType(request.clientId, request.type, request.settings);
		},
		getGroupMonitorTypes ({ commit, getters }, request) {
			return GroupRepository.getMonitorType(request.clientId, request.groupId, request.type, request.settings);
		},
		getDeviceMonitorTypes ({ commit, getters }, request) {
			return DeviceRepository.getMonitorType(request.clientId, request.groupId, request.deviceId, request.type, request.settings);
		},
		deleteMonitor ({ commit, getters }, id) {
			return MonitorRepository.deleteMonitor(id);
		},
		storeMonitor ({ commit, getters }, request) {
			return MonitorRepository.storeMonitor(
				request.type, request.clientId, request.name, request.monitorType, request.condition, request.timezone,
				request.fnt, request.cron, request.isActive, request.magTemplate, request.settings, request.use_schedule
			);
		},
		updateMonitor ({ commit, getters }, request) {
			return MonitorRepository.updateMonitor(
				request.monitorId, request.type, request.clientId, request.name, request.monitorType, request.condition,
				request.timezone, request.fnt, request.cron, request.isActive, request.magTemplate, request.settings
			);
		},
		activateMonitor ({ commit, getters }, id) {
			return MonitorRepository.activateMonitor(id);
		},
		deactivateMonitor ({ commit, getters }, id) {
			return MonitorRepository.deactivateMonitor(id);
		},
		overrideMonitor ({ commit, getters }, request) {
			return MonitorRepository.overrideMonitor(request.monitorId, request.type, request.id);
		},
		activateInheritedMonitor ({ commit, getters }, request) {
			return MonitorRepository.activateInheritedMonitor(request.monitorId, request.type, request.id);
		},
		deactivateInheritedMonitor ({ commit, getters }, request) {
			return MonitorRepository.deactivateInheritedMonitor(request.monitorId, request.type, request.id);
		},
		details ({ commit, getters }, request) {
			return MonitorRepository.getDetails(request.id, request.qs);
		},
		runMonitor ({ commit, getters }, requestData) {
			return MonitorRepository.runMonitor(requestData.monitorId, requestData);
		},
		getActionTypes ({ commit, getters }, clientId) {
			return MonitorRepository.actionTypes(clientId);
		},
		saveActionGroupTemplate ({ commit, getters }, request) {
			return MonitorRepository.storeActionGroupTemplate(request);
		},
		updateActionGroupTemplate ({ commit, getters }, request) {
			return MonitorRepository.updateActionGroupTemplate(request.id, request.requestData);
		},
		getActionGroupTemplate ({ commit, getters }, id) {
			return MonitorRepository.getActionGroupTemplate(id);
		},
		testAction ({ commit, getters }, request) {
			return MonitorRepository.testActions(request.monitorId, request);
		}
	},
	getters: {
		getMonitorActionTemplateAll: (state) => Object.values(state.monitorActionTemplateAll)
	}
};
